export default __webpack_public_path__ + "static/media/Icon7_On.1cf7afbe.png";